import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';
import { getCategoryCount } from '@/lib/content';

const toneIcon: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategorySection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="六个入口，覆盖职场信息的主要关切"
          desc="每条观察都归属于一个明确的主题，你可以按自己当前的处境选择对应的入口。"
          align="center"
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="h-36 w-full overflow-hidden">
                <img
                  src={cat.cover}
                  alt={`${cat.name}主题配图`}
                  title={`${cat.name} - 职场观察主题分类`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-2.5">
                    <span
                      className={`flex h-9 w-9 items-center justify-center rounded-md ${toneIcon[cat.tone]}`}
                    >
                      <i className={`${cat.icon} text-lg`} />
                    </span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                  </div>
                  <span className="font-label text-xs text-foreground-500">
                    {getCategoryCount(cat.slug)} 篇
                  </span>
                </div>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{cat.short}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-label text-sm text-primary-700">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}